import api from '@pray/shared/utils/api';

type GetArticleSuggestionsProps = {
  artistId: string;
  articleId: string;
  property: 'title' | 'excerpt';
};

type ArticleSuggestionsResponse = {
  suggestions: string[];
};

export async function getArticleSuggestions({ artistId, articleId, property }: GetArticleSuggestionsProps) {
  if (!artistId) throw Error('Artist ID is required');
  if (!articleId) throw Error('Article ID is required');

  const url = `/web/studio/artists/${artistId}/articles/${articleId}/suggestions`;

  const response = await api.executeGetRequest(url, { property });

  return (response.data as any)?.data as ArticleSuggestionsResponse;
}
